import { interfaces } from 'inversify/lib/interfaces/interfaces';

import { DINotFoundDependencyError } from '../errors/not-found-dependency';
import { getOverrideTarget } from './override-target-getter';

type service<T> = interfaces.Newable<T>;
type getter<T> = (serviceIdentifier: interfaces.Newable<T>) => T;
type check<T> = (serviceIdentifier: interfaces.Newable<T>) => boolean;

export function getDependencies<T>(serviceId: service<T>, getter: getter<T>, checkBound: check<T>, optional: true): T | undefined;
export function getDependencies<T>(serviceId: service<T>, getter: getter<T>, checkBound: check<T>, optional?: false): T;
export function getDependencies<T>(serviceId: service<T>, getter: getter<T>, checkBound: check<T>, optional = false): T | undefined {
  const overrideTarget = getOverrideTarget(serviceId);

  if (optional && !checkBound(serviceId)) {
    return undefined;
  }

  const result = getter(overrideTarget || serviceId);

  if (!result) {
    throw new DINotFoundDependencyError();
  }

  return result;
}
